import { useAuth } from "@/context/auth-provider";
import { SubscriptionProvider } from "@/context/subscription-provider";
import React from "react";

export const SubscriptionWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { access } = useAuth();

  return (
    <SubscriptionProvider isAuthenticated={!!access}>
      {children}
    </SubscriptionProvider>
  );
};
